import apiClient from './apiClient';

export const getMyReferrals = () =>
  apiClient.get('/api/referrals/me').then((res) => res.data);
